import { useGetQuery } from '../useGetQuery'
import { usePostQuery } from '../usePostQuery'

export const useQueue = ({ id } = {}) => {
  const { data, isFetching, reFetch } = useGetQuery({ url: `/queue/${id}`, enabled: !!id })
  return { queue: data?.queue, isFetching, reFetch }
}

export const useJoinQueue = () => {
  const { post, isFetching } = usePostQuery({ method: 'PUT' })
  return {
    joinQueue: (id, payload) => post(payload, `/queue/${id}/players`),
    isFetching
  }
}
